import { render } from "./Instrunction.vue?vue&type=template&id=5436f7fb"
import script from "./Instrunction.vue?vue&type=script&lang=js"
export * from "./Instrunction.vue?vue&type=script&lang=js"

import "./Instrunction.vue?vue&type=style&index=0&id=5436f7fb&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__